import { confirm } from "devextreme/ui/dialog";
import { useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AR, FileTypes } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useSubmitDesign } from "../api/submit-design";
import { RetailOrderContext } from "../context/RetailOrderContext";
import RetailOrderFiles from "./RetailOrderFiles";

export default function DesignPacketFiles() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const returnUrl = encodeURIComponent(searchParams.get("returnUrl") ?? "");

	const submitDesign = useSubmitDesign(
		order.details.retailOrderID,
		(result) => {
			showSuccessMessage("Design has been submitted");
			refetchOrder()
				.then(() => {
					if (result.activeARs.includes(120)) {
						const to = `/cfi/retail-order/${order.details.retailOrderID}/120` +
							(!!returnUrl ? '?returnUrl=' + returnUrl : '');

						navigate(to);
					}
				})
		},
		(error) => showErrorMessage(error)
	);

	return (
		<RetailOrderFiles
			fileTypes={[FileTypes.CabinetDesignPacket, FileTypes.CabinetMeasureWorksheet]}
			defaultFileType={FileTypes.CabinetDesignPacket}
			buttonCaption={order.details.activeARs.includes(AR.DealerToSubmitCabinetDesign) ?
				'Upload Cabinet Design Packet' : undefined}
			replaceFile={true}
			onFileAdded={(fileType: FileTypes) => {
				if (fileType === FileTypes.CabinetDesignPacket) {
					confirm("Do you want to submit the file?", "Submit File")
						.then((result) => {
							if (result) {
								submitDesign.mutate();
							}
						});
				}
			}}
		/>
	)
}
